import React, { useState } from "react"
import { OptionButton } from "./option-button"
import { CustomInput } from "./custom-input"

const RADIUS = {
  none: 0,
  normal: 6,
  large: 12
}

function allRadiiMatch(properties, value) {
  return (
    properties.borderTopLeftRadius === value &&
    properties.borderTopRightRadius === value &&
    properties.borderBottomLeftRadius === value &&
    properties.borderBottomRightRadius === value
  )
}

function getBorderRadius(properties) {
  if (allRadiiMatch(properties, RADIUS.none)) return "none"
  if (allRadiiMatch(properties, RADIUS.normal)) return "normal"
  if (allRadiiMatch(properties, RADIUS.large)) return "large"
  return "custom"
}

export function BorderRadius({ properties, update }) {
  const radius = getBorderRadius(properties)
  const [showCustom, setShowCustom] = useState(radius === "custom")

  function handleClick(size) {
    setShowCustom(false)
    update({
      borderTopRightRadius: RADIUS[size],
      borderTopLeftRadius: RADIUS[size],
      borderBottomRightRadius: RADIUS[size],
      borderBottomLeftRadius: RADIUS[size]
    })
  }

  return (
    <div>
      <div className="font-semibold text-gray-700 mb-1">Border radius</div>
      <div className="flex border rounded mb-2">
        <div className="p-1 flex items-center justify-center flex-grow border-r">
          <OptionButton
            active={radius === "none" && !showCustom}
            onClick={() => handleClick("none")}
          >
            None
          </OptionButton>
          <OptionButton
            active={radius === "normal" && !showCustom}
            onClick={() => handleClick("normal")}
          >
            Normal
          </OptionButton>
          <OptionButton
            active={radius === "large" && !showCustom}
            onClick={() => handleClick("large")}
          >
            Large
          </OptionButton>
        </div>
        <div className="p-1 flex items-center justify-center">
          <OptionButton
            active={radius === "custom" || showCustom}
            onClick={() => setShowCustom(true)}
          >
            Custom
          </OptionButton>
        </div>
      </div>

      {showCustom && (
        <div className="grid grid-cols-2 gap-2">
          <CustomInput
            label="Top"
            value={properties.borderTopLeftRadius}
            onChange={value =>
              update({
                borderTopLeftRadius: value,
                borderTopRightRadius: value
              })
            }
          />

          <CustomInput
            label="Bottom"
            value={properties.borderBottomLeftRadius}
            onChange={value =>
              update({
                borderBottomLeftRadius: value,
                borderBottomRightRadius: value
              })
            }
          />
        </div>
      )}
    </div>
  )
}
